export enum LocalStorageItems {
  Language = 'VT_lang',
  TripFilterAreaToggleKey = 'VT_trip-filter-area-state-open',
  FleetFilterAreaToggleKey = 'VT_fleet-filter-area-state-open',
  OnCallFilterAreaToggleKey = 'VT_on-call-filter-area-state-open',
  VismaExpenseState = 've_state',
  NavMenuToggleKey = 'VT_nav-menu-state-open',
  ShowReleaseDialog = 'VT_show-release-dialog',
  LatestRenewedVersion = 'VT_latest-renewed-v',
  VehicleFilterAreaToggleKey = 'VT_vehicles-filter-area-state-open',
}
